import {Typography, Avatar, Box, Fab} from '@mui/material';
import {MouseEventHandler} from 'react';
import {useTranslation} from 'react-i18next';
import {MdPersonAddAlt1} from 'react-icons/md';
import {translations} from '../../../i18n/translations';

export default function UserAvatarButton({
  name,
  pictureUrl,
  onClick,
}: {
  name: string;
  pictureUrl?: string;
  onClick?: MouseEventHandler<any> | undefined;
}) {
  const {t} = useTranslation();
  const initial = name && name.length > 0 ? name[0] : '-';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Fab
        onClick={onClick}
        aria-label={name}
        sx={{
          padding: 0,
          width: '64px',
          height: '64px',
          marginBottom: '8px',
        }}
      >
        <Avatar alt={name} className="avatar-all" src={pictureUrl}>
          {initial === '+' && <MdPersonAddAlt1 />}
        </Avatar>
      </Fab>
      <Typography className="user-name">
        {initial === '+' ? `${t(translations.quick_access_login.all_users)}` : name}
      </Typography>
    </Box>
  );
}
